import { NavLink } from 'react-router-dom';

import s from './GoToReport.module.css';



const GoToReport = () => {

  return (
    <div className={s.goToReport}>
      <NavLink to="/reports" className={s.link}>
        <p style={{ marginRight: 20 }}>Перейти к отчетам</p>
        <svg
          width="14"
          height="14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path className={s.icon}
            d="M0 4.2h3V14H0V4.2ZM5.6 0h2.8v14H5.6V0Zm5.6 8H14v6h-2.8V8Z"
            fill="#52555F"
          />
        </svg>
      </NavLink>
    </div>
  );
};

export default GoToReport;